import { render, staticRenderFns } from "./BracketFinalParticipant.vue?vue&type=template&id=76d3713d&"
import script from "./BracketFinalParticipant.vue?vue&type=script&lang=js&"
export * from "./BracketFinalParticipant.vue?vue&type=script&lang=js&"
import style0 from "./BracketFinalParticipant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports